import {ImageGallery} from "../Interfaces/ImageGallery";
import {AxiosConfig} from "./AxiosConfig/AxiosConfig";

export const blobsRootFolderName = "@root/";

export const formatImageLink = (link: string) => {
    let formattedLink = link.replace(blobsRootFolderName, "");
    if (formattedLink.startsWith("/")) formattedLink = formattedLink.substring(1, formattedLink.length);
    if (formattedLink.endsWith("/")) formattedLink = formattedLink.substring(0, formattedLink.length - 1);
    return formattedLink;
}

export const retrieveBlobImages = () => {
    return new Promise<Array<ImageGallery>>((resolve) => {
        return AxiosConfig.instance.get(`/images`).then(res => {
            let images = "error" in res.data ? new Array<ImageGallery>() : res.data as Array<ImageGallery>;
            images = images.map(img => {
                const formattedImg: ImageGallery = {...img};
                formattedImg.imageLink = blobsRootFolderName + formatImageLink(formattedImg.imageLink);
                // If it's a folder
                if (formattedImg.imageLink.endsWith("/root"))
                    formattedImg.imageLink = formattedImg.imageLink.substring(0, formattedImg.imageLink.lastIndexOf("/") + 1);
                return formattedImg;
            });
            return resolve(images);
        }).catch(error => {
            console.error(error)
            resolve(new Array<ImageGallery>());
        });
    });
}

export const getBlobImage = (imageLink: string): Promise<ImageGallery | undefined> => {
    return new Promise<ImageGallery | undefined>((resolve) => {
        return AxiosConfig.instance.get(`/images/link?imageLink=${formatImageLink(imageLink)}`).then(res => {
            return resolve(res.data);
        }).catch(error => {
            console.error(error);
            resolve(undefined);
        });
    });
}

export const uploadBlobImage = (image: ImageGallery): Promise<boolean> => {
    const data: ImageGallery = {...image};
    data.imageLink = formatImageLink(data.imageLink);
    return new Promise<boolean>((resolve) => {
        return AxiosConfig.instance.post("/images", data).then(() => {
            return resolve(true);
        }).catch(error => {
            console.error(error);
            resolve(false);
        });
    });
}

export const uploadBlobFolder = (folderPath: string): Promise<boolean> => {
    return new Promise<boolean>((resolve) => {
        uploadBlobImage({imageLink: formatImageLink(folderPath), content: ""})
            .then(success => resolve(success))
            .catch(e => {
                console.error(e);
                resolve(false)
            })
    });
}

export const updateBlobImage = (oldImageLink: string, newImageLink: string) => {
    const data = {
        oldImageLink: formatImageLink(oldImageLink),
        newImageLink: formatImageLink(newImageLink)
    };
    return new Promise<boolean>((resolve) => {
        return AxiosConfig.instance.put(`/images`, data).then(() => {
            return resolve(true);
        }).catch(error => {
            console.error(error);
            resolve(false);
        });
    });
}

export const deleteBlobImage = (imageLink: string): Promise<boolean> => {
    return new Promise<boolean>(resolve => {
        return AxiosConfig.instance.delete(`/images?imageLink=${encodeURIComponent(formatImageLink(imageLink))}`).then(() => {
            return resolve(true);
        }).catch(error => {
            console.error(error);
            resolve(false);
        });
    });
}

export const deleteBlobFolder = (folderPath: string): Promise<boolean> => {
    return new Promise<boolean>(resolve => {
        return AxiosConfig.instance.delete(`/images/all?folderPath=${encodeURIComponent(formatImageLink(folderPath))}`).then(() => {
            return resolve(true);
        }).catch(error => {
            console.error(error);
            resolve(false);
        });
    });
}